import { observer } from 'mobx-react-lite';
import { Header, Icon, Segment } from 'semantic-ui-react';

export default observer(function ServerError() {
    
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='help' />
                There is an unexpected error! Please try again later. 
            </Header>                     
        </Segment>
    )
})